import { render } from "./Task.vue?vue&type=template&id=4bf4bb7c"
import script from "./Task.vue?vue&type=script&lang=js"
export * from "./Task.vue?vue&type=script&lang=js"

import "./Task.vue?vue&type=style&index=0&id=4bf4bb7c&scope=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__